/* iFungi — buy-box script shared by every product buy box (2026-10-21, Claude).
 *
 * Replaces assets/ifungi-lf7-buybox.js and assets/ifungi-ps7-buybox.js, which were two near-copies of
 * the same code. Each buy box keeps its own markup, ids and classes ("lf7-…", "ps7-…") and its inline
 * price JSON (#<prefix>-dynamic-prices, rendered by Liquid). What differs between products is in
 * PRODUCTS below; a new product = a buy-box section with a new prefix + one entry here.
 *
 * Loaded with defer by sections/lf7-buybox.liquid and sections/ps7-buybox.liquid, after
 * assets/ifungi-buybox-cart.js (window.iFungiBuyboxCart: add, "View cart" protection).
 *
 * Kept from the two scripts (dates refer to their history in git):
 *  - cart page only: after Shopify confirms the exact variant and selling plan, go to the active
 *    market's cart URL (2026-09-20);
 *  - ?variant=, ?selling_plan= and ?purchase=onetime links, validated against Shopify's plan
 *    allocations, and the URL kept in step with the selection (2026-10-13);
 *  - prices from Shopify allocations, in cents; percentage maths only as a fallback (2026-10-02/13);
 *  - Shopify availability: sold-out choices marked and blocked; a $0.00 price blocks the add (2026-08-14);
 *  - a Shopify 4xx refusal shows Shopify's reason; an unconfirmed add turns the button into
 *    "View cart" and never sends a second add (2026-10-03/13);
 *  - screen-reader announcements for the button and for price changes (2026-10-02/16);
 *  - the gallery follows the selected variant's image (2026-10-13).
 * Window names other scripts read stay the same: <prefix>State, <prefix>Variants (flat bag map for a
 * one-size product), <prefix>VariantMedia, <prefix>RebuildAllCdds, and the
 * ifungi:<prefix>-variant-change event.
 */
(function () {
  if (window.__ifungiBuyboxLoaded) return; /* each buy-box section includes this script */
  window.__ifungiBuyboxLoaded = true;

  var PRODUCTS = {
    lf7: {
      label: 'Life Force 7',
      handle: 'mushroom-powder-life-force-7',
      roots: ['.lf7-buybox-section', '.ifungi-section-wrapper-lf7_buybox'],
      sizes: ['60g', '150g'],          /* pack_variants keyed by size, then bag count */
      defaultSize: '150g',
      daysPerBag: { '60g': 60, '150g': 150 },
      announceServings: true,          /* "150 servings, 3 bags, one-time purchase: $269.95" */
      eachFr: 'ch',
      priceInBrackets: false,          /* "3 Bags $89.98 ea Save $30" */
      savingsVs: 'regular',            /* regular (pre-sale) 1-bag price × bags */
      saveOnOneBag: true,
      badgesInList: false,             /* Best Seller / Best Value come from assets/ifungi-lf7-aov.js */
      frotherAddon: true,
      lockSubscribeWhenSoldOut: false,
      gallery: { swipe: 30, swipeOnGallery: true, tapToAdvance: true, thumbStep: 216 },
      reviewsAnchors: ['customer-reviews']
    },
    ps7: {
      label: 'PetShrooms 7',
      handle: 'natural-pet-supplement-petshrooms-7',
      roots: ['.ps7-buybox-section', '.ps7-hero'],
      sizes: null,                     /* one size: pack_variants keyed by bag count */
      daysPerBag: 100,                 /* 100g bag = 100 days at 1g/day */
      announceServings: false,
      eachFr: 'ch.',
      priceInBrackets: true,           /* "3 Bags ($31.95 ea) Save $24 Best Seller" */
      savingsVs: 'single',             /* the 1-bag price × bags */
      saveOnOneBag: false,
      badgesInList: true,
      frotherAddon: false,
      lockSubscribeWhenSoldOut: true,  /* Subscribe & Save is a one-bag offer */
      gallery: { swipe: 40, swipeOnGallery: false, tapToAdvance: false, thumbStep: 240 },
      reviewsAnchors: ['customer-reviews-ps7', 'customer-reviews']
    }
  };

  var LANG = (document.documentElement.lang || 'en').split('-')[0];
  var FR = LANG === 'fr';
  var PACKS = [['1 Bag', 1], ['2 Bags', 2], ['3 Bags', 3], ['5 Bags', 5]];
  var BAGS = { '1 Bag': 1, '2 Bags': 2, '3 Bags': 3, '5 Bags': 5 };
  var SOLD_OUT = FR ? 'Épuisé' : 'Sold out';

  /* A subscription discount in whole cents, rounded the way Shopify charges the line (half up);
     floating-point maths showed some prices 1 cent low (2026-10-02). */
  function discountedPrice(price, pct) {
    var amount = Number(price);
    if (!isFinite(amount) || !(pct > 0)) return amount;
    var cents = Math.round(amount * 100);
    return Math.round(cents * (100 - pct) / 100) / 100;
  }
  /* "Save $X" labels round up to a whole unit ("Save $30"); prices keep their cents. */
  function savingsMoney(amount, symbol) {
    var cents = Math.max(0, Math.round(Number(amount) * 100));
    var whole = Math.ceil(cents / 100);
    if (window.iFungiMoney) return window.iFungiMoney.fromAmount(whole, 0);
    return (symbol || '$') + whole.toFixed(0);
  }
  function escapeText(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  /* Swap only the amount inside merchant-formatted HTML ("Only $0.67/day — …"), keeping its tags. */
  function replaceAmount(tpl, newAmt) {
    if (!tpl) return newAmt;
    /* innerHTML returns the French non-breaking space as an entity (2026-10-02). */
    tpl = String(tpl).replace(/&nbsp;/g, ' ');
    var reEn = /\$\d{1,4}(?:[.,]\d{1,2})?/;
    if (reEn.test(tpl)) return tpl.replace(reEn, newAmt);
    /* International market: the server rendered the amount in the shopper's currency (2026-10-18). */
    var reCur = window.iFungiMoney && window.iFungiMoney.pattern;
    if (reCur && reCur.test(tpl)) return tpl.replace(reCur, newAmt);
    /* French "24,99 $" (non-breaking space since 2026-08-22; the no-space form still matches). */
    var reFr = /\d{1,4}[,.]\d{1,2}[\s ]*\$/;
    if (reFr.test(tpl)) {
      var numOnly = newAmt.replace(/[^0-9.,]/g, '').replace(',', '.');
      return tpl.replace(reFr, parseFloat(numOnly).toFixed(2).replace('.', ',') + ' $');
    }
    return newAmt;
  }
  function announce(message) {
    var region = document.getElementById('status-announcement');
    if (!region || !message) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, 60);
  }
  function urlParam(name) {
    try { return new URL(window.location.href).searchParams.get(name); } catch (e) { return null; }
  }

  function initBuybox(P, cfg) {
    var atcRoot = document.getElementById(P + '-atc-btn');
    var root = atcRoot && (cfg.roots.map(function (sel) { return atcRoot.closest(sel); }).filter(Boolean)[0] || atcRoot.parentElement);
    if (!root || root.getAttribute('data-ifungi-' + P + '-buybox-initialized') === 'true') return;
    root.setAttribute('data-ifungi-' + P + '-buybox-initialized', 'true');

    var byId = function (name) { return document.getElementById(P + '-' + name); };
    var i18n = {
      bagSingular: FR ? 'Sachet' : 'Bag',
      bagPlural: FR ? 'Sachets' : 'Bags',
      each: FR ? cfg.eachFr : 'ea',
      save: FR ? 'Économisez' : 'Save',
      bestSeller: FR ? 'Meilleur vendeur' : 'Best Seller',
      bestValue: FR ? 'Meilleure valeur' : 'Best Value'
    };
    function bagWord(bags) { return bags === 1 ? '1 ' + i18n.bagSingular : bags + ' ' + i18n.bagPlural; }

    controller();
    customDropdowns();
    gallery();
    thumbArrows();
    starsLink();
    servingsWord();
    bagImageClass();

    /* ===== Prices, purchase options and Add to Cart ===== */
    function controller() {
      function disableBuybox() {
        var btn = byId('atc-btn');
        if (!btn) return;
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = FR ? 'Indisponible' : 'Unavailable';
      }
      /* A missing or broken price block leaves a safely disabled buy box, not a live-looking dead one
         (2026-08-14); valid JSON without usable prices too (2026-10-15). */
      var data;
      try {
        data = JSON.parse(byId('dynamic-prices').textContent);
      } catch (e) {
        console.error('[' + P + '] dynamic price data missing or malformed; buy box disabled:', e);
        disableBuybox();
        return;
      }
      var priceBlocks = data && data.prices;
      var hasPrices = !!(priceBlocks && typeof priceBlocks === 'object' && Object.keys(priceBlocks).some(function (k) {
        var blk = priceBlocks[k];
        return !!(blk && blk.variants && typeof blk.variants === 'object' && Object.keys(blk.variants).length);
      }));
      if (!hasPrices) {
        console.error('[' + P + '] dynamic price data has no usable prices; buy box disabled');
        disableBuybox();
        return;
      }

      var routes = data.routes || { cart_url: '/cart', cart_add_url: '/cart/add.js' };
      var messages = data.messages || { adding: 'Adding…', adding_item: 'Adding your item…', added_updating_cart: 'Added — updating your cart…', try_again: 'Try again', unavailable: 'Unavailable', add_to_cart_unavailable: 'This option is currently unavailable' };
      var activeCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'CAD';
      /* If the active currency block is missing, use whichever one Liquid emitted (2026-05-17). */
      var currData = data.prices[activeCurrency] || data.prices[data.active_currency] || data.prices['CAD'] || data.prices[Object.keys(data.prices || {})[0]] || { currency_symbol: '$', currency_suffix: '', variants: {} };
      var currSymbol = currData.currency_symbol || '$';
      var currSuffix = ''; /* symbols only; activeCurrency still selects the market */
      var currCode = activeCurrency;
      var dynPrices = currData.variants;
      var originalPrices = currData.original_prices || {}; /* pre-sale prices, for strikethroughs */
      var saleActive = data.sale_active || false;

      /* Pack variant IDs come from Shopify (pack_variants), never typed in; a pack Shopify doesn't
         return is kept with no id and shows as unavailable (2026-10-15/16). */
      var sizes = cfg.sizes || ['default'];
      var packIds = data.pack_variants || {};
      var variants = {};
      sizes.forEach(function (size) {
        var ids = cfg.sizes ? (packIds[size] || {}) : packIds;
        variants[size] = {};
        PACKS.forEach(function (pack) {
          var raw = ids[String(pack[1])];
          var id = raw ? parseInt(raw, 10) : NaN;
          var ok = Number.isFinite(id) && id > 0;
          variants[size][pack[0]] = { id: ok ? id : null, price: ok ? (dynPrices[String(id)] || 0) / 100 : 0, bags: pack[1], missing: !ok };
        });
      });
      /* Availability, selling-plan allocations and variant images from Shopify. Missing data is treated
         as available / unrestricted, so an older section copy keeps working (2026-10-13). */
      var availability = data.availability || {};
      var variantPlans = data.variant_plans || null;
      var allocationPrices = data.allocation_prices || {}; /* cents, by variant then plan */
      var variantMedia = data.variant_media || {};
      sizes.forEach(function (size) {
        Object.keys(variants[size]).forEach(function (qty) {
          var entry = variants[size][qty];
          entry.available = !entry.missing && availability[String(entry.id)] !== false;
        });
      });
      function allocationPrice(variantId, planId) {
        if (!variantId || !planId) return null;
        var byPlan = allocationPrices[String(variantId)];
        if (!byPlan || !Object.prototype.hasOwnProperty.call(byPlan, String(planId))) return null;
        var cents = Number(byPlan[String(planId)]);
        /* Zero/invalid data is not a missing allocation: the availability gate handles it. */
        return Number.isFinite(cents) && cents >= 0 ? cents / 100 : 0;
      }
      function selectedPrice(variant, planId, fallbackDiscount) {
        if (!variant) return 0;
        if (planId) {
          var allocated = allocationPrice(variant.id, planId);
          if (allocated !== null) return allocated;
          return discountedPrice(variant.price, fallbackDiscount); /* only without this exact allocation */
        }
        return variant.price;
      }
      function planAllowed(variantId, planId) {
        if (!planId) return false;
        if (!variantPlans) return true;
        var list = variantPlans[String(variantId)];
        return !!(list && list.map(String).indexOf(String(planId)) !== -1);
      }
      function onProductPage() {
        return new RegExp('/products/' + cfg.handle + '/?$').test(window.location.pathname || '');
      }
      function formatPrice(amount) {
        if (window.iFungiMoney) return window.iFungiMoney.fromAmount(amount) + currSuffix;
        return currSymbol + amount.toFixed(2) + currSuffix;
      }
      function regularSinglePrice(sizeData) {
        var single = sizeData && sizeData['1 Bag'];
        if (!single) return 0;
        return (saleActive && originalPrices[String(single.id)]) ? originalPrices[String(single.id)] / 100 : single.price;
      }

      /* Selection and button state, declared before the first update() so an initial "Unavailable"
         label can never become the saved button label (2026-10-13). */
      var currentSize = cfg.defaultSize || sizes[0];
      var currentQty = '1 Bag';
      var currentSellingPlan = null; /* null = one-time */
      var currentSubDiscount = 0;    /* percent */
      var atcBtn = byId('atc-btn');
      var atcOriginalHTML = atcBtn ? atcBtn.innerHTML : 'Add to Cart';
      var adding = false;
      var showingUnavailable = false;
      var viewCartMode = false;
      var confirmedCartMode = false;
      var retryMode = false;
      var recheckTimer = null;
      var noticeKind = '';
      function current() { return variants[currentSize] && variants[currentSize][currentQty]; }

      var initialVariantId = parseInt(data.initial_variant_id, 10);
      if (Number.isFinite(initialVariantId)) {
        sizes.some(function (size) {
          return Object.keys(variants[size]).some(function (qty) {
            if (variants[size][qty].id !== initialVariantId) return false;
            currentSize = size; currentQty = qty;
            return true;
          });
        });
      }
      /* Open on an available choice; an explicit ?variant= link keeps its own variant (and shows
         "Sold out" if it is), so the shopper sees what they asked for (2026-10-13). */
      if (!urlParam('variant') && current() && current().available === false) {
        var otherSizes = sizes.filter(function (s) { return s !== currentSize; });
        var order = [[currentSize, '1 Bag']]
          .concat(otherSizes.map(function (s) { return [s, '1 Bag']; }))
          .concat(['2 Bags', '3 Bags', '5 Bags'].map(function (q) { return [currentSize, q]; }));
        otherSizes.forEach(function (s) { ['2 Bags', '3 Bags', '5 Bags'].forEach(function (q) { order.push([s, q]); }); });
        order.some(function (pair) {
          var candidate = variants[pair[0]] && variants[pair[0]][pair[1]];
          if (!candidate || candidate.available === false) return false;
          currentSize = pair[0]; currentQty = pair[1];
          return true;
        });
      }

      /* Size buttons (products with sizes) */
      var sizeBtns = document.querySelectorAll('#' + P + '-size-row .' + P + '-variant-btn');
      function syncSizeAvailability() {
        sizeBtns.forEach(function (btn) {
          var size = btn.getAttribute('data-size');
          var sizeData = variants[size];
          var anyAvailable = !!sizeData && Object.keys(sizeData).some(function (q) { return sizeData[q].available !== false; });
          var tagId = P + '-size-soldout-' + size;
          btn.classList.toggle('is-sold-out', !anyAvailable);
          if (!anyAvailable) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-describedby', tagId); }
          else { btn.removeAttribute('aria-disabled'); if ((btn.getAttribute('aria-describedby') || '').indexOf(P + '-size-soldout-') === 0) btn.removeAttribute('aria-describedby'); }
          var tag = document.getElementById(tagId);
          if (!anyAvailable && !tag) {
            tag = document.createElement('span');
            tag.id = tagId;
            tag.className = P + '-size-soldout';
            tag.textContent = SOLD_OUT;
            btn.appendChild(tag);
          } else if (anyAvailable && tag) { tag.remove(); }
        });
      }
      syncSizeAvailability();
      sizeBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-size') === currentSize;
        btn.classList.toggle('active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      /* A one-time choice is URL state only after the shopper picks it (or a shared one-time link). */
      var explicitOneTime = onProductPage() && urlParam('purchase') === 'onetime';
      function syncVariantUrl() {
        if (!onProductPage()) return;
        var selected = current();
        if (!selected || !window.history || !window.history.replaceState) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(selected.id));
          /* A valid selling plan wins over a stale one-time marker. */
          if (currentSellingPlan) {
            url.searchParams.set('selling_plan', String(currentSellingPlan));
            url.searchParams.delete('purchase');
            explicitOneTime = false;
          } else {
            url.searchParams.delete('selling_plan');
            if (explicitOneTime) url.searchParams.set('purchase', 'onetime');
            else url.searchParams.delete('purchase');
          }
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }

      /* Price, price-per-day, and the Subscribe & Save box keep the merchant's formatting: only the
         amount inside the rendered HTML is swapped. */
      var priceEl = byId('price');
      var priceTpl = priceEl ? priceEl.innerHTML : '';
      var perDayEl = byId('per-day');
      var perDayAmountEl = perDayEl && (perDayEl.querySelector('.' + P + '-per-day__amount') || byId('per-day-text'));
      var perDayTpl = perDayAmountEl ? perDayAmountEl.innerHTML : '';
      function updatePerDay() {
        var v = current() || (variants[currentSize] && variants[currentSize]['1 Bag']);
        if (!v || !perDayAmountEl) return;
        var days = typeof cfg.daysPerBag === 'number' ? cfg.daysPerBag : (cfg.daysPerBag[currentSize] || 60);
        var perDay = selectedPrice(v, currentSellingPlan, currentSubDiscount) / (v.bags || 1) / days;
        perDayAmountEl.innerHTML = replaceAmount(perDayTpl, formatPrice(perDay));
      }

      /* Frother add-on (LF7): ticked, it is added with the product and express checkout is hidden. */
      var frotherAddon = cfg.frotherAddon ? document.querySelector('[data-ifungi-frother-addon]') : null;
      var frotherToggle = frotherAddon && frotherAddon.querySelector('[data-ifungi-frother-addon-toggle]');
      var frotherExpressNote = frotherAddon && frotherAddon.querySelector('[data-ifungi-frother-express-note]');
      function frotherSelected() { return !!(frotherToggle && frotherToggle.checked); }
      if (frotherToggle) frotherToggle.addEventListener('change', function () {
        syncExpressForm();
        if (frotherExpressNote) frotherExpressNote.hidden = !frotherSelected();
        if (frotherToggle.checked) {
          announce((FR ? 'Paiement express masqué. ' : 'Express checkout hidden. ') + (frotherExpressNote ? String(frotherExpressNote.textContent || '').replace(/\s+/g, ' ').trim() : ''));
        } else {
          announce(FR ? 'Paiement express de nouveau disponible.' : 'Express checkout available again.');
        }
      });
      if (frotherExpressNote) frotherExpressNote.hidden = !frotherSelected();

      /* Quantity dropdowns: every copy on the page stays in step. */
      var qtySelectEls = document.querySelectorAll('.' + P + '-qty-dropdown');
      function syncAllDropdownsTo(value) {
        for (var i = 0; i < qtySelectEls.length; i++) { try { qtySelectEls[i].value = value; } catch (e) {} }
      }
      /* The hidden native <select> labels (the visible list is built by customDropdowns()). */
      function refreshNativeOptions() {
        if (!qtySelectEls.length) return;
        var sizeData = variants[currentSize];
        if (!sizeData) return;
        for (var d = 0; d < qtySelectEls.length; d++) {
          var sel = qtySelectEls[d];
          for (var i = 0; i < sel.options.length; i++) {
            var opt = sel.options[i];
            var bags = BAGS[opt.value];
            var entry = sizeData[opt.value];
            if (!bags || !entry) continue;
            var effective = selectedPrice(entry, currentSellingPlan, currentSubDiscount);
            var ppb = formatPrice(effective / bags);
            var ppbText = cfg.priceInBrackets ? ' (' + ppb + ' ' + i18n.each + ')' : ' ' + ppb + ' ' + i18n.each;
            var base = cfg.savingsVs === 'regular'
              ? regularSinglePrice(sizeData) * bags
              : selectedPrice(sizeData['1 Bag'], currentSellingPlan, currentSubDiscount) * bags;
            var savings = base - effective;
            var savText = (savings > 0.01 && (cfg.saveOnOneBag || bags > 1)) ? ' ' + i18n.save + ' ' + savingsMoney(savings, currSymbol) : '';
            var badge = cfg.badgesInList ? (bags === 3 ? ' ' + i18n.bestSeller : bags === 5 ? ' ' + i18n.bestValue : '') : '';
            var soldOut = entry.available === false;
            opt.text = bagWord(bags) + ppbText + savText + badge + (soldOut ? ' — ' + SOLD_OUT : '');
            opt.disabled = soldOut;
          }
        }
      }

      /* Express checkout forms carry the selected variant and plan; hidden while the price is not
         purchasable or the frother is ticked. */
      function syncExpressForm() {
        var forms = document.querySelectorAll('.' + P + '-express-form');
        var v = current();
        if (!forms.length || !v) return;
        var canExpress = priceValid() && !frotherSelected();
        forms.forEach(function (form) {
          var idInput = form.querySelector('.' + P + '-express-variant-id');
          var planInput = form.querySelector('.' + P + '-express-selling-plan');
          if (idInput) idInput.value = v.id;
          if (planInput) {
            planInput.value = currentSellingPlan || '';
            planInput.disabled = !currentSellingPlan;
          }
          form.hidden = !canExpress;
          form.setAttribute('aria-hidden', canExpress ? 'false' : 'true');
        });
      }

      function update() {
        var v = current();
        if (v && priceEl) priceEl.innerHTML = replaceAmount(priceTpl, formatPrice(selectedPrice(v, currentSellingPlan, currentSubDiscount)));
        /* Sale mode (PS7): the struck-through regular price follows the selected pack (2026-10-15). */
        var wasEl = byId('price-was');
        if (v && wasEl && saleActive && originalPrices[String(v.id)]) wasEl.textContent = formatPrice(originalPrices[String(v.id)] / 100);
        /* Subscribe & Save box: regular 1-bag price struck through, next to the subscription price of
           the chosen (or best) plan; the "up to" price uses Shopify's best plan percentage (max_plan_pct). */
        try {
          if (v) {
            var single = variants[currentSize]['1 Bag'];
            var planForBox = currentSellingPlan || (freqSelect && freqSelect.value) || null;
            var maxSubPct = (currentSubDiscount > 0) ? currentSubDiscount : (Number(data.max_plan_pct) > 0 ? Number(data.max_plan_pct) : 15);
            var regular = single ? regularSinglePrice(variants[currentSize]) : v.price;
            var subPrice = selectedPrice(single, planForBox, maxSubPct);
            document.querySelectorAll('#' + P + '-sub-orig, .' + P + '-sub-pricebox__orig').forEach(function (el) { el.textContent = formatPrice(regular); });
            document.querySelectorAll('#' + P + '-sub-disc, .' + P + '-sub-pricebox__disc').forEach(function (el) { el.textContent = formatPrice(subPrice); });
          }
        } catch (e) {}
        updatePerDay();
        syncExpressForm();
        updateAvailability();
        /* A refusal note belongs to the choice that was refused (2026-10-13). */
        if (noticeKind === 'refused') { var staleNote = noteEl(false); if (staleNote) staleNote.hidden = true; noticeKind = ''; }
        if (v) { try { document.dispatchEvent(new CustomEvent('ifungi:' + P + '-variant-change', { detail: { variantId: v.id, size: currentSize, quantity: currentQty } })); } catch (e) {} }
        queuePriceAnnouncement();
      }

      sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-disabled') === 'true') return; /* whole size sold out */
          sizeBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
          currentSize = btn.getAttribute('data-size');
          update(); refreshNativeOptions(); syncVariantUrl();
        });
      });
      syncAllDropdownsTo(currentQty);
      qtySelectEls.forEach(function (el) {
        el.addEventListener('change', function () {
          currentQty = el.value;
          syncAllDropdownsTo(currentQty);
          update(); syncVariantUrl(); refreshNativeOptions();
        });
      });

      /* ===== Purchase type (Shopify selling plans) ===== */
      var purchaseRadios = document.querySelectorAll('input[name="' + P + '-purchase-type"]');
      var freqWrap = byId('delivery-freq-wrap');
      var freqSelect = byId('delivery-freq');
      var deliveryCards = document.querySelectorAll('.' + P + '-delivery-card');
      function radio(value) { return document.querySelector('input[name="' + P + '-purchase-type"][value="' + value + '"]'); }
      function syncDeliveryCardActiveStates() {
        deliveryCards.forEach(function (card) {
          var r = card.querySelector('input[type="radio"]');
          card.classList.toggle('is-active', !!(r && r.checked));
        });
      }
      function setOneTimeQtyMenuOpen(qtyWrap, open) {
        if (!qtyWrap) return;
        var cdd = qtyWrap.querySelector('.' + P + '-cdd--qty');
        var trigger = cdd && cdd.querySelector('.' + P + '-cdd-trigger');
        var panel = cdd && cdd.querySelector('.' + P + '-cdd-panel');
        qtyWrap.classList.toggle(P + '-qty-open', !!open);
        if (cdd) cdd.setAttribute('data-expanded', open ? 'true' : 'false');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      }
      function subscriptionAvailable() {
        var single = variants[currentSize] && variants[currentSize]['1 Bag'];
        return !!(single && single.available !== false);
      }
      /* PS7: with its one-bag variant sold out, Subscribe & Save is disabled and falls back to one-time.
         Returns true when it had to switch the shopper back to one-time. */
      function syncSubscriptionAvailability() {
        if (!cfg.lockSubscribeWhenSoldOut) return false;
        var sub = radio('subscribe');
        if (!sub) return false;
        var card = sub.closest('.' + P + '-delivery-card');
        var allowed = subscriptionAvailable();
        sub.disabled = !allowed;
        if (card) {
          card.classList.toggle('is-disabled', !allowed);
          card.setAttribute('aria-disabled', allowed ? 'false' : 'true');
        }
        if (!allowed && sub.checked) {
          var oneTime = radio('onetime');
          if (oneTime) { oneTime.checked = true; return true; }
        }
        return false;
      }
      function applyPurchaseTypeChange() {
        var checked = document.querySelector('input[name="' + P + '-purchase-type"]:checked');
        var val = checked ? checked.value : 'onetime';
        if (val === 'subscribe' && cfg.lockSubscribeWhenSoldOut && !subscriptionAvailable()) {
          var forced = radio('onetime');
          if (forced) { forced.checked = true; val = 'onetime'; }
        }
        var qtyWrap = byId('qty-onetime-wrap');
        if (val === 'subscribe') {
          if (freqWrap) freqWrap.hidden = false;
          if (qtyWrap) { qtyWrap.hidden = true; setOneTimeQtyMenuOpen(qtyWrap, false); }
          /* Subscriptions are single-bag; shoppers raise the quantity in the cart. */
          currentQty = '1 Bag';
          syncAllDropdownsTo('1 Bag');
          if (freqSelect) {
            currentSellingPlan = freqSelect.value;
            var opt = freqSelect.options[freqSelect.selectedIndex];
            currentSubDiscount = opt ? parseFloat(opt.getAttribute('data-discount') || '0') : 0;
          }
        } else {
          if (freqWrap) freqWrap.hidden = true;
          if (qtyWrap) qtyWrap.hidden = false;
          currentSellingPlan = null;
          currentSubDiscount = 0;
          /* The one-time pack list stays open in normal page flow, never covering Add to Cart. */
          if (qtyWrap) setOneTimeQtyMenuOpen(qtyWrap, true);
        }
        syncDeliveryCardActiveStates();
        update();
        refreshNativeOptions();
        syncExpressForm();
        syncVariantUrl();
      }
      purchaseRadios.forEach(function (r) {
        r.addEventListener('change', function () {
          if (!r.checked) return;
          /* Only a shopper's radio choice opts into (or clears) the one-time URL marker. */
          explicitOneTime = r.value === 'onetime';
          applyPurchaseTypeChange();
        });
      });
      /* Multipack links stay on their pack: subscriptions are single-bag, so open them as one-time. */
      if (currentQty !== '1 Bag') { var initialOneTime = radio('onetime'); if (initialOneTime) initialOneTime.checked = true; }
      /* A valid ?selling_plan= wins (subscription reminder/cart/email links); otherwise only an exact
         purchase=onetime overrides the server default. */
      var requestedPlan = onProductPage() ? urlParam('selling_plan') : null;
      var planLinkHonoured = false;
      if (requestedPlan) {
        var single = variants[currentSize] && variants[currentSize]['1 Bag'];
        var planOption = null;
        if (freqSelect) {
          for (var i = 0; i < freqSelect.options.length; i++) {
            if (String(freqSelect.options[i].value) === String(requestedPlan)) { planOption = freqSelect.options[i]; break; }
          }
        }
        var subscribeRadio = radio('subscribe');
        if (currentQty === '1 Bag' && single && planOption && subscribeRadio && planAllowed(single.id, requestedPlan)) {
          freqSelect.value = planOption.value;
          subscribeRadio.checked = true;
          explicitOneTime = false;
          planLinkHonoured = true;
        } else {
          showPlanLinkNote();
        }
      }
      if (!planLinkHonoured && explicitOneTime) { var oneTimeRadio = radio('onetime'); if (oneTimeRadio) oneTimeRadio.checked = true; }
      function showPlanLinkNote() {
        var row = byId('delivery-row');
        if (!row || byId('plan-link-note')) return;
        var note = document.createElement('p');
        note.id = P + '-plan-link-note';
        note.setAttribute('role', 'status');
        note.className = P + '-plan-link-note';
        note.textContent = FR
          ? 'L’option d’abonnement de votre lien n’est pas offerte pour ce choix. Vérifiez votre sélection ci-dessous.'
          : 'The subscription option in your link isn’t available for this choice. Please check your selection below.';
        row.parentNode.insertBefore(note, row);
      }
      try { applyPurchaseTypeChange(); } catch (e) { console.warn(P + ' init applyPurchaseTypeChange failed', e); }
      if (freqSelect) {
        freqSelect.addEventListener('change', function () {
          currentSellingPlan = freqSelect.value;
          var opt = freqSelect.options[freqSelect.selectedIndex];
          currentSubDiscount = opt ? parseFloat(opt.getAttribute('data-discount') || '0') : 0;
          update(); refreshNativeOptions(); syncExpressForm(); syncVariantUrl();
        });
      }
      syncDeliveryCardActiveStates();

      /* ===== Add to Cart state ===== */
      /* A $0.00 / missing price or a sold-out variant is not purchasable (2026-08-14, 2026-10-13). */
      function priceValid() {
        var v = current();
        var price = selectedPrice(v, currentSellingPlan, currentSubDiscount);
        return !!(v && Number.isFinite(price) && price > 0 && v.available !== false);
      }
      function updateAvailability() {
        if (syncSubscriptionAvailability()) { applyPurchaseTypeChange(); return; }
        if (!atcBtn || adding || viewCartMode) return; /* don't fight an add, an error or "View cart" */
        if (priceValid()) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
          if (showingUnavailable) { atcBtn.innerHTML = atcOriginalHTML; showingUnavailable = false; }
          if (retryMode) atcBtn.textContent = messages.try_again;
        } else {
          retryMode = false;
          var v = current();
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.textContent = (v && v.available === false) ? SOLD_OUT : messages.unavailable;
          showingUnavailable = true;
        }
      }

      /* Screen-reader users hear the new price after they change the selection: not on page load, once
         after a burst of changes, never the same summary twice (2026-10-16). */
      var priceAnnounceReady = false;
      var priceAnnounceTimer = null;
      var lastPriceAnnounce = '';
      var announceRows = ['size-row', 'delivery-row', 'qty-row'].map(function (r) { return '#' + P + '-' + r; }).join(', ');
      ['click', 'change', 'keydown'].forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          var t = e.target;
          if (t && t.closest && t.closest(announceRows)) priceAnnounceReady = true;
        }, true);
      });
      function queuePriceAnnouncement() {
        if (!priceAnnounceReady) return;
        clearTimeout(priceAnnounceTimer);
        priceAnnounceTimer = setTimeout(function () {
          var v = current();
          if (!v || !(v.price > 0)) return;
          var bags = v.bags || 1;
          var parts = [];
          if (cfg.announceServings) parts.push((parseInt(currentSize, 10) || '') + (FR ? ' portions' : ' servings'));
          parts.push(bags + ' ' + (bags === 1 ? (FR ? 'sachet' : 'bag') : (FR ? 'sachets' : 'bags')));
          if (currentSellingPlan) {
            var fo = freqSelect && freqSelect.options[freqSelect.selectedIndex];
            var freq = fo ? String(fo.textContent || '').split(/—|–/)[0].replace(/\s+/g, ' ').trim() : '';
            parts.push((FR ? 'abonnement' : 'Subscribe & Save') + (freq ? ', ' + freq.toLowerCase() : ''));
          } else {
            parts.push(FR ? 'achat unique' : 'one-time purchase');
          }
          var msg = parts.join(', ') + (FR ? ' : ' : ': ') + formatPrice(selectedPrice(v, currentSellingPlan, currentSubDiscount));
          if (msg === lastPriceAnnounce) return;
          lastPriceAnnounce = msg;
          announce(msg);
        }, 600);
      }

      /* After an add whose outcome could not be confirmed, the button becomes "View cart" and only
         navigates; it never sends a second add (2026-10-03). Each product resolves only its own
         attempt records, with fresh reads on every page load (2026-10-11). */
      var viewCartLabel = FR ? 'Voir le panier' : 'View cart';
      var checkingCartLabel = FR ? 'Vérification du panier…' : 'Checking your cart…';
      var cartUnreachableNote = FR
        ? 'Impossible de joindre le panier pour le moment. Vérifiez votre connexion et réessayez.'
        : 'We couldn’t reach your cart just now. Check your connection and try again.';
      var unresolvedNote = FR
        ? 'Nous n’avons pas pu confirmer si cet article a été ajouté. Consultez le panier avant d’ajouter à nouveau.'
        : 'We couldn’t confirm whether this item was added. View cart to check before adding again.';
      var retryNote = FR
        ? 'L’article n’apparaît pas dans votre panier après plusieurs vérifications. Veuillez réessayer.'
        : 'This item did not appear in your cart after several checks. Please try again.';
      var confirmedNote = FR
        ? 'Votre article est dans le panier. Consultez le panier pour continuer.'
        : 'Your item is in your cart. View cart to continue.';
      function frotherHint(protectedCase) {
        if (protectedCase) return FR
          ? ' Si ' + cfg.label + ' n’a pas été ajouté, décochez le mousseur pour l’ajouter seul.'
          : ' If ' + cfg.label + ' was not added, untick the frother to add it on its own.';
        return FR
          ? ' Décochez le mousseur pour ajouter ' + cfg.label + ' seul.'
          : ' Untick the frother to add ' + cfg.label + ' on its own.';
      }
      function noteEl(create) {
        var note = byId('add-unresolved-note');
        if (!note && create && atcBtn) {
          note = document.createElement('p');
          note.id = P + '-add-unresolved-note';
          note.setAttribute('role', 'status');
          note.style.cssText = 'margin:8px 0 0;font-size:13px;line-height:1.4;color:#7a2e0e;text-align:center;';
          atcBtn.insertAdjacentElement('afterend', note);
        }
        return note;
      }
      function showNote(text, kind) {
        var note = noteEl(true);
        if (note) { note.textContent = text; note.hidden = false; }
        if (kind) noticeKind = kind;
      }
      /* Fresh, guarded evidence that this exact add is absent: the shopper may retry by tapping. */
      function showRetry() {
        leaveViewCart(true);
        retryMode = true;
        if (atcBtn) { atcBtn.disabled = false; atcBtn.removeAttribute('aria-disabled'); atcBtn.textContent = messages.try_again; }
        showNote(retryNote, 'retry');
        announce(messages.try_again + '. ' + retryNote);
      }
      /* Shopify refused the add outright (4xx such as sold out or a quantity limit): say why. */
      function isRefusal(e) {
        var status = e ? Number(e.status) : NaN;
        return status >= 400 && status < 500 && status !== 408 && status !== 429;
      }
      function showRefusal(e, withFrother) {
        var reason = e && typeof e.message === 'string' ? e.message.trim() : '';
        if (!reason || /^(Cart request failed|Unable to add item to cart)$/i.test(reason)) reason = messages.add_to_cart_unavailable;
        if (withFrother) reason += frotherHint(false);
        showNote(reason, 'refused');
        atcBtn.textContent = messages.add_to_cart_unavailable;
        announce(reason);
        setTimeout(function () { if (!adding && !viewCartMode) { atcBtn.innerHTML = atcOriginalHTML; showingUnavailable = false; updateAvailability(); } }, 2500);
      }
      /* An unresolved attempt can still carry Shopify's refusal reason: keep "View cart", show the reason. */
      function showProtectedRefusal(e, withFrother) {
        var reason = e && typeof e.refusalMessage === 'string' ? e.refusalMessage.trim() : '';
        if (!reason) return;
        reason += FR ? ' Vérifiez votre panier avant d’ajouter à nouveau.' : ' Check your cart before adding again.';
        if (withFrother) reason += frotherHint(true);
        showNote(reason, 'protected-refusal');
        announce(reason);
      }
      function pendingRecheckDelay() {
        var helper = window.iFungiBuyboxCart;
        var fallback = 120000, minimum = 250;
        if (!helper || typeof helper.getPending !== 'function') return fallback;
        var due = helper.getPending(P).map(function (entry) { return Number(entry && entry.recheckAt); })
          .filter(function (at) { return Number.isFinite(at) && at > 0; });
        if (!due.length) return fallback;
        return Math.max(minimum, Math.min.apply(Math, due) - Date.now());
      }
      function scheduleRecheck() {
        if (recheckTimer) clearTimeout(recheckTimer);
        if (!viewCartMode || confirmedCartMode) return;
        recheckTimer = setTimeout(function () {
          recheckTimer = null;
          if (viewCartMode && !adding) resolvePendingAdd();
        }, pendingRecheckDelay());
      }
      function confirmViewCart() {
        enterViewCart();
        confirmedCartMode = true;
        if (recheckTimer) { clearTimeout(recheckTimer); recheckTimer = null; }
        showNote(confirmedNote);
        announce(confirmedNote);
      }
      function enterViewCart() {
        confirmedCartMode = false;
        viewCartMode = true;
        adding = false;
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.textContent = viewCartLabel;
        atcBtn.setAttribute('data-ifungi-view-cart', 'true');
        showNote(unresolvedNote);
        announce(unresolvedNote);
        scheduleRecheck();
      }
      function leaveViewCart(preserveRetry) {
        confirmedCartMode = false;
        if (recheckTimer) { clearTimeout(recheckTimer); recheckTimer = null; }
        viewCartMode = false;
        if (!preserveRetry) retryMode = false;
        atcBtn.removeAttribute('data-ifungi-view-cart');
        var note = noteEl(false); if (note) note.hidden = true;
        showingUnavailable = false;
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.innerHTML = atcOriginalHTML;
        updateAvailability();
      }
      function resolvePendingAdd() {
        var helper = window.iFungiBuyboxCart;
        if (!helper || !helper.hasUnresolved || !helper.hasUnresolved(P)) {
          if (viewCartMode && !confirmedCartMode) leaveViewCart();
          return;
        }
        viewCartMode = true;
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.textContent = checkingCartLabel;
        atcBtn.setAttribute('data-ifungi-view-cart', 'true');
        helper.resolveUnresolved(P).then(function (outcome) {
          if (outcome === 'added') confirmViewCart();
          else if (outcome === 'absent') showRetry();
          else if (outcome === 'none') leaveViewCart();
          else enterViewCart();
        }, function () { enterViewCart(); });
      }
      if (window.iFungiBuyboxCart && window.iFungiBuyboxCart.registerProduct) {
        var pendingVariantIds = [];
        sizes.forEach(function (size) {
          Object.keys(variants[size]).forEach(function (qty) { if (variants[size][qty].id) pendingVariantIds.push(variants[size][qty].id); });
        });
        window.iFungiBuyboxCart.registerProduct(P, pendingVariantIds);
      }
      if (atcBtn) atcBtn.addEventListener('click', function () {
        if (viewCartMode) {
          if (atcBtn.disabled) return;
          /* Read the cart first, so a dead connection is caught here with the remembered attempt intact.
             The tap never clears that attempt; the cart page does (2026-10-03). */
          var helper = window.iFungiBuyboxCart;
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.textContent = checkingCartLabel;
          announce(checkingCartLabel);
          var restoreViewCart = function (message) {
            atcBtn.disabled = false;
            atcBtn.removeAttribute('aria-disabled');
            atcBtn.textContent = viewCartLabel;
            if (message) { showNote(message); announce(message); }
          };
          Promise.resolve().then(function () {
            return (helper && helper.resolveUnresolved) ? helper.resolveUnresolved(P) : 'none';
          }).then(function (outcome) {
            if (outcome === 'unreadable') { restoreViewCart(cartUnreachableNote); return; }
            if (outcome === 'absent') { showRetry(); return; }
            atcBtn.textContent = viewCartLabel;
            window.location.assign(routes.cart_url || '/cart');
          }, function () { restoreViewCart(cartUnreachableNote); });
          return;
        }
        if (adding) return;
        retryMode = false; /* a "Try again" tap is the only action that may start a new add */
        var v = current();
        if (!v) return;
        if (!priceValid()) { updateAvailability(); return; }

        adding = true;
        var navigationStarted = false;
        var withFrother = frotherSelected();
        if (noticeKind) { var oldNote = noteEl(false); if (oldNote) oldNote.hidden = true; noticeKind = ''; }
        atcBtn.disabled = true;
        atcBtn.textContent = messages.adding;
        announce(messages.adding);

        Promise.resolve().then(function () {
          if (!window.iFungiBuyboxCart) throw new Error('iFungi cart transport is unavailable');
          /* The label names the product in the cart page's notice if this add cannot be confirmed. */
          var items = [{ variantId: v.id, quantity: 1, sellingPlan: currentSellingPlan, label: cfg.label }];
          if (withFrother) {
            var frotherVariantId = parseInt(frotherAddon.getAttribute('data-frother-variant-id'), 10);
            if (!frotherVariantId) throw new Error('Frother variant is unavailable');
            items.push({ variantId: frotherVariantId, quantity: 1, label: FR ? 'Mousseur' : 'Frother' });
          }
          return window.iFungiBuyboxCart.addLines(routes, { items: items, productKey: P });
        }).then(function () {
          /* Shopify accepted the exact variant and plan: the cart page is the only cart. */
          navigationStarted = true;
          atcBtn.textContent = messages.added_updating_cart;
          window.location.assign(routes.cart_url || '/cart');
        }).catch(function (e) {
          console.error('Add to cart error:', e);
          if (e && e.unresolved) { enterViewCart(); showProtectedRefusal(e, withFrother); return; }
          if (viewCartMode) return; /* restored from the Back/Forward cache mid-add: that state wins */
          if (isRefusal(e)) { showRefusal(e, withFrother); return; }
          if (e && e.retryable) { showRetry(); return; }
          atcBtn.textContent = messages.try_again;
          announce(atcBtn.textContent);
          setTimeout(function () { atcBtn.innerHTML = atcOriginalHTML; updateAvailability(); }, 2000);
        }).finally(function () {
          adding = false;
          if (!navigationStarted && !viewCartMode) atcBtn.disabled = false;
        });
      });
      /* Back from the cart: the browser may restore this page with the button still on "Adding…". */
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted || !atcBtn) return;
        adding = false;
        var helper = window.iFungiBuyboxCart;
        if (helper && helper.hasUnresolved && helper.hasUnresolved(P)) resolvePendingAdd();
        else leaveViewCart();
      });
      if (atcBtn) resolvePendingAdd();

      update();
      refreshNativeOptions();
      syncExpressForm();

      /* State for the dropdown lists, the sticky bar (ifungi-sticky-cart.js), the add-ons
         (ifungi-lf7-aov.js, ifungi-ps7-aov.js) and the gallery. */
      window[P + 'Variants'] = cfg.sizes ? variants : variants[sizes[0]];
      window[P + 'VariantMedia'] = variantMedia;
      var state = window[P + 'State'] = window[P + 'State'] || {};
      var getters = {
        currentSize: function () { return currentSize; },
        currentQty: function () { return currentQty; },
        currSymbol: function () { return currSymbol; },
        currSuffix: function () { return currSuffix; },
        currCode: function () { return currCode; },
        currentSubDiscount: function () { return currentSubDiscount; },
        currentSellingPlan: function () { return currentSellingPlan; },
        currentVariantId: function () { var v = current(); return v ? v.id : null; },
        currentPrice: function () { return selectedPrice(current(), currentSellingPlan, currentSubDiscount); },
        regularSinglePrice: function () { return regularSinglePrice(variants[currentSize]); },
        sizeData: function () { return variants[currentSize] || null; }
      };
      Object.keys(getters).forEach(function (name) {
        Object.defineProperty(state, name, { get: getters[name], configurable: true });
      });
    }

    /* ===== Custom dropdowns: the visible lists built from the hidden native <select>s ===== */
    function customDropdowns() {
      function money(amount, st) {
        return (window.iFungiMoney ? window.iFungiMoney.fromAmount(amount) : (st.currSymbol || '$') + amount.toFixed(2)) + (st.currSuffix || '');
      }
      function qtyOptionHTML(value, sizeData) {
        var bags = BAGS[value];
        if (!bags) return '<span class="' + P + '-cdd-bagcount">' + escapeText(value) + '</span>';
        if (!sizeData || !sizeData[value]) return '<span class="' + P + '-cdd-bagcount">' + bagWord(bags) + '</span>';
        var st = window[P + 'State'] || {};
        var subDisc = st.currentSubDiscount || 0;
        var singlePrice = sizeData['1 Bag'] ? sizeData['1 Bag'].price : sizeData[value].price;
        /* The selected row shows the controller's exact allocation; other rows are one-time choices. */
        var selected = Number(st.currentPrice);
        var effective = (value === st.currentQty && Number.isFinite(selected) && selected > 0)
          ? selected
          : discountedPrice(sizeData[value].price, subDisc);
        var ppb = money(effective / bags, st);
        var ppbText = cfg.priceInBrackets ? ' (' + ppb + ' ' + i18n.each + ')' : ' ' + ppb + ' ' + i18n.each;
        var base = cfg.savingsVs === 'regular'
          ? (st.regularSinglePrice || singlePrice) * bags
          : discountedPrice(singlePrice, subDisc) * bags;
        var savings = base - effective;
        var savHtml = (savings > 0.01 && (cfg.saveOnOneBag || bags > 1))
          ? ' <span class="' + P + '-cdd-save">' + i18n.save + ' ' + savingsMoney(savings, st.currSymbol) + '</span>'
          : '';
        var badge = !cfg.badgesInList ? ''
          : bags === 3 ? ' <span class="' + P + '-cdd-best-seller">' + i18n.bestSeller + '</span>'
          : bags === 5 ? ' <span class="' + P + '-cdd-best-value">' + i18n.bestValue + '</span>'
          : '';
        var sold = sizeData[value].available === false ? ' <span class="' + P + '-cdd-soldout">' + SOLD_OUT + '</span>' : '';
        return '<span class="' + P + '-cdd-bagcount">' + bagWord(bags) + '</span>' + ppbText + savHtml + badge + sold;
      }
      /* "Every month — Save 15%" → name + green saving. Plan names are app data: escaped. */
      function freqOptionHTML(text) {
        var parts = String(text || '').split(/—|–/);
        if (parts.length >= 2) {
          return escapeText(parts[0].trim()) + ' <span class="' + P + '-cdd-save">' + escapeText(parts.slice(1).join('—').trim()) + '</span>';
        }
        return escapeText(text);
      }
      function isKind(cdd, kind) {
        return cdd.getAttribute('data-cdd-target') === kind || cdd.classList.contains(P + '-cdd--' + kind);
      }
      function optionHTML(cdd, opt, sizeData) {
        if (isKind(cdd, 'qty')) return qtyOptionHTML(opt.value, sizeData);
        if (isKind(cdd, 'freq')) return freqOptionHTML(opt.textContent);
        return escapeText(opt.textContent);
      }
      function rebuildPanel(cdd) {
        var sel = cdd.querySelector('select.' + P + '-cdd-native');
        var panel = cdd.querySelector('.' + P + '-cdd-panel');
        var trigger = cdd.querySelector('.' + P + '-cdd-trigger__label');
        if (!sel || !panel) return;
        var st = window[P + 'State'] || {};
        var sizeData = st.sizeData || null;
        panel.innerHTML = '';
        for (var i = 0; i < sel.options.length; i++) {
          var opt = sel.options[i];
          var li = document.createElement('li');
          li.className = P + '-cdd-option';
          li.setAttribute('role', 'option');
          li.setAttribute('data-value', opt.value);
          li.setAttribute('aria-selected', opt.value === sel.value ? 'true' : 'false');
          if (opt.disabled) { li.setAttribute('aria-disabled', 'true'); li.classList.add('is-disabled'); }
          var txtSpan = document.createElement('span');
          txtSpan.className = P + '-cdd-option__text';
          txtSpan.innerHTML = optionHTML(cdd, opt, sizeData);
          var radioSpan = document.createElement('span');
          radioSpan.className = P + '-cdd-option__radio';
          li.appendChild(txtSpan);
          li.appendChild(radioSpan);
          panel.appendChild(li);
        }
        var selectedOpt = sel.options[sel.selectedIndex];
        if (trigger && selectedOpt) trigger.innerHTML = optionHTML(cdd, selectedOpt, sizeData);
      }
      /* The one-time pack list stays open while one-time is chosen. */
      function keptOpen(cdd) { return isKind(cdd, 'qty') && !!cdd.closest('#' + P + '-qty-onetime-wrap.' + P + '-qty-open'); }
      function setOpen(cdd, open) {
        var btn = cdd.querySelector('.' + P + '-cdd-trigger');
        var pnl = cdd.querySelector('.' + P + '-cdd-panel');
        cdd.setAttribute('data-expanded', open ? 'true' : 'false');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (pnl) pnl.hidden = !open;
      }
      function closeAllExcept(except) {
        document.querySelectorAll('.' + P + '-cdd[data-expanded="true"]').forEach(function (el) {
          if (el !== except && !keptOpen(el)) setOpen(el, false);
        });
      }
      function attachCdd(cdd) {
        var sel = cdd.querySelector('select.' + P + '-cdd-native');
        var btn = cdd.querySelector('.' + P + '-cdd-trigger');
        var panel = cdd.querySelector('.' + P + '-cdd-panel');
        if (!sel || !btn || !panel) return;
        rebuildPanel(cdd);
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (keptOpen(cdd)) { setOpen(cdd, true); return; }
          if (cdd.getAttribute('data-expanded') === 'true') { setOpen(cdd, false); return; }
          closeAllExcept(cdd);
          rebuildPanel(cdd);
          setOpen(cdd, true);
        });
        panel.addEventListener('click', function (e) {
          var li = e.target.closest('.' + P + '-cdd-option');
          if (!li) return;
          e.stopPropagation();
          if (li.getAttribute('aria-disabled') === 'true') return; /* sold-out choice */
          var val = li.getAttribute('data-value');
          if (sel.value !== val) {
            sel.value = val;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          var qtyWrap = byId('qty-onetime-wrap');
          var keepVisible = isKind(cdd, 'qty') && qtyWrap && !qtyWrap.hidden;
          setOpen(cdd, !!keepVisible);
          if (keepVisible) qtyWrap.classList.add(P + '-qty-open');
          rebuildPanel(cdd);
        });
        /* Other code changing the select (purchase type, sticky bar) updates the list too. */
        sel.addEventListener('change', function () { rebuildPanel(cdd); });
      }
      document.addEventListener('click', function () { closeAllExcept(null); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllExcept(null); });
      document.querySelectorAll('.' + P + '-cdd').forEach(attachCdd);

      /* Size, purchase-type and frequency changes move prices without a change event on the lists. */
      var rebuildAll = window[P + 'RebuildAllCdds'] = function () {
        document.querySelectorAll('.' + P + '-cdd').forEach(rebuildPanel);
      };
      var later = function () { setTimeout(rebuildAll, 0); };
      document.querySelectorAll('#' + P + '-size-row .' + P + '-variant-btn, .' + P + '-size-btn').forEach(function (b) { b.addEventListener('click', later); });
      document.querySelectorAll('input[name="' + P + '-purchase-type"]').forEach(function (r) { r.addEventListener('change', later); });
      var freq = byId('delivery-freq');
      if (freq) freq.addEventListener('change', later);
    }

    /* ===== Product photo gallery ===== */
    /* Thumbnails are named buttons with aria-current on the selected one; the gallery follows the
       selected variant's image (2026-10-13); phones get a phone-sized photo via srcset (2026-10-16). */
    function gallery() {
      var g = cfg.gallery;
      var box = document.querySelector('.' + P + '-hero-gallery');
      if (!box) return;
      var thumbs = box.querySelectorAll('.' + P + '-hero-thumb');
      var mainImgs = box.querySelectorAll('.' + P + '-hero-main-img');
      if (!thumbs.length || !mainImgs.length) return;
      var prevBtn = box.querySelector('.' + P + '-carousel-prev');
      var nextBtn = box.querySelector('.' + P + '-carousel-next');
      var ci = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('active')) ci = i; });
      function thumbControl(t) { return (t.closest && t.closest('.' + P + '-hero-thumb-btn')) || t; }
      function goTo(idx, opts) {
        if (idx < 0) idx = thumbs.length - 1;
        if (idx >= thumbs.length) idx = 0;
        ci = idx;
        thumbs.forEach(function (t) {
          t.classList.remove('active');
          var c = thumbControl(t); if (c !== t) c.removeAttribute('aria-current');
        });
        thumbs[idx].classList.add('active');
        var control = thumbControl(thumbs[idx]); if (control !== thumbs[idx]) control.setAttribute('aria-current', 'true');
        var src = thumbs[idx].getAttribute('data-main-src') || thumbs[idx].src.replace('&width=150', '').replace('?width=150', '');
        var srcset = thumbs[idx].getAttribute('data-main-srcset');
        var alt = thumbs[idx].getAttribute('data-main-alt');
        mainImgs.forEach(function (img) {
          if (img.getAttribute('src') === src && (!srcset || img.getAttribute('srcset') === srcset)) return;
          if (srcset) img.setAttribute('srcset', srcset); else { img.removeAttribute('srcset'); img.removeAttribute('sizes'); }
          img.src = src;
          if (alt !== null) img.alt = alt;
        });
        if (!(opts && opts.noScroll)) {
          /* Scroll only the thumbnail strip; scrollIntoView would also scroll the page. */
          var strip = thumbs[idx].closest('.' + P + '-hero-thumbs');
          if (strip) {
            var left = control.offsetLeft - (strip.clientWidth - control.offsetWidth) / 2;
            try { strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (e) { strip.scrollLeft = Math.max(0, left); }
          }
        }
      }
      function indexForMedia(mediaId) {
        if (!mediaId) return -1;
        for (var i = 0; i < thumbs.length; i++) {
          if (String(thumbControl(thumbs[i]).getAttribute('data-media-id') || thumbs[i].getAttribute('data-media-id')) === String(mediaId)) return i;
        }
        return -1;
      }
      function mediaFor(variantId) { var m = window[P + 'VariantMedia']; return m && m[String(variantId)]; }
      document.addEventListener('ifungi:' + P + '-variant-change', function (e) {
        if (!e || !e.detail || !e.detail.variantId) return;
        var idx = indexForMedia(mediaFor(e.detail.variantId));
        if (idx >= 0 && idx !== ci) goTo(idx);
      });
      /* The buy box initialises first; catch up with its current choice. */
      var st = window[P + 'State'];
      if (st && st.currentVariantId) {
        var initialIdx = indexForMedia(mediaFor(st.currentVariantId));
        if (initialIdx >= 0 && initialIdx !== ci) goTo(initialIdx, { noScroll: true });
      }
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(ci - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(ci + 1); });
      thumbs.forEach(function (t, i) { thumbControl(t).addEventListener('click', function (e) { e.preventDefault(); goTo(i); }); });
      var sx = 0, sy = 0, dragging = false;
      function onSwipeStart(e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; dragging = true; }
      function onSwipeEnd(e) {
        if (!dragging) return; dragging = false;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > g.swipe) { if (dx < 0) goTo(ci + 1); else goTo(ci - 1); }
      }
      mainImgs.forEach(function (img) {
        img.addEventListener('touchstart', onSwipeStart, { passive: true });
        img.addEventListener('touchend', onSwipeEnd, { passive: true });
      });
      if (g.swipeOnGallery) {
        /* Taps between and around the images swipe too. */
        box.addEventListener('touchstart', onSwipeStart, { passive: true });
        box.addEventListener('touchend', onSwipeEnd, { passive: true });
      }
      if (g.tapToAdvance) {
        /* A tap (not a swipe) on the right half of the photo goes forward, on the left half back. */
        mainImgs.forEach(function (img) {
          img.addEventListener('click', function (e) {
            if (Math.abs(e.clientX - sx) >= 10) return;
            var rect = img.getBoundingClientRect();
            if (e.clientX - rect.left > rect.width / 2) goTo(ci + 1); else goTo(ci - 1);
          });
        });
      }
      box.setAttribute('tabindex', '0');
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', FR
        ? 'Photos du produit. Flèches gauche et droite pour changer de photo.'
        : 'Product photos. Use the left and right arrow keys to change photo.');
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(ci - 1);
        if (e.key === 'ArrowRight') goTo(ci + 1);
      });
    }

    /* Thumbnail strip arrows */
    function thumbArrows() {
      var strip = document.querySelector('.' + P + '-hero-thumbs');
      var prev = document.querySelector('.' + P + '-thumb-prev');
      var next = document.querySelector('.' + P + '-thumb-next');
      if (!strip || !prev || !next) return;
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); strip.scrollBy({ left: -cfg.gallery.thumbStep, behavior: 'smooth' }); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); strip.scrollBy({ left: cfg.gallery.thumbStep, behavior: 'smooth' }); });
    }

    /* The stars line scrolls smoothly to the reviews (falling back when its anchor is missing). */
    function starsLink() {
      document.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('a.' + P + '-stars-line');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.getElementById(href.slice(1));
        for (var i = 0; !target && i < cfg.reviewsAnchors.length; i++) target = document.getElementById(cfg.reviewsAnchors[i]);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Wrap the word "servings" in the size buttons so it can shrink on phones. */
    function servingsWord() {
      document.querySelectorAll('.' + P + '-size-weight').forEach(function (el) {
        if (el.querySelector('.' + P + '-size-servings-word')) return;
        var t = el.textContent;
        if (!t || !/servings/i.test(t)) return;
        el.innerHTML = t.replace(/(servings)/i, '<span class="' + P + '-size-servings-word">$1</span>');
      });
    }

    /* Main photos marked data-bag-marker get .is-transparent-bag while showing the cut-out bag image. */
    function bagImageClass() {
      var imgs = document.querySelectorAll('.' + P + '-hero-main-img[data-bag-marker]');
      if (!imgs.length) return;
      function sync() {
        imgs.forEach(function (img) {
          img.classList.toggle('is-transparent-bag', (img.getAttribute('src') || '').indexOf(img.getAttribute('data-bag-marker')) >= 0);
        });
      }
      sync();
      if (typeof MutationObserver !== 'undefined') {
        imgs.forEach(function (img) { new MutationObserver(sync).observe(img, { attributes: true, attributeFilter: ['src'] }); });
      }
    }
  }

  function initAll() {
    Object.keys(PRODUCTS).forEach(function (P) {
      if (document.getElementById(P + '-dynamic-prices') || document.getElementById(P + '-atc-btn')) initBuybox(P, PRODUCTS[P]);
    });
  }
  initAll();
  /* Theme editor (2026-10-22): changing a buy-box section's settings re-renders it as new markup without the
     "initialized" marker; start that buy box again instead of leaving it dead until the editor is refreshed. */
  document.addEventListener('shopify:section:load', initAll);

  /* FAQ cards (.ifungi-faq-card) in the buy boxes: one open at a time, aria-expanded kept in step.
     sections/faq.liquid shares this guard. */
  if (!window.__ifungiFAQDelegated) {
    window.__ifungiFAQDelegated = true;
    document.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('.ifungi-faq-q');
      if (!q) return;
      var card = q.closest('.ifungi-faq-card');
      if (!card) return;
      var group = card.closest('.ifungi-faq-cards');
      var wasOpen = card.classList.contains('open');
      if (group) {
        group.querySelectorAll('.ifungi-faq-card.open').forEach(function (other) {
          if (other === card) return;
          other.classList.remove('open');
          var oq = other.querySelector('.ifungi-faq-q');
          if (oq) oq.setAttribute('aria-expanded', 'false');
        });
      }
      card.classList.toggle('open', !wasOpen);
      q.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
    }, false);
  }
})();
